function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
var LSCheckout = {
  stepperStep: 0,
  checkoutStep: 0,
  submitButtons: [],
  ecProduct: null,
  slider: null,
  isShowingCCData: false,
  initialize: function initialize() {
    var _this = this,
      _clientData$orderData;
    this.stepperStep = clientData.page.currentStep;

    // always starts at #0
    window.history.replaceState(null, null, '#' + this.checkoutStep);
    window.onhashchange = function () {
      _this.onhashchange();
    };
    LSCart.initialize({
      $el: $('.cart'),
      $itemTpl: $('.templates .cart-item'),
      $optionsContainer: $('.container-add-ons'),
      isFreeAllowed: clientData.page.isFreeCartAllowed
    });
    LSCheckoutProcessor.initialize({
      $payForm: $('#payForm'),
      submitButtons: this.submitButtons
    });
    this.initPreselectedAddon(); // from qs param
    this.initAddonButtons(); // for LSCart.items (localstorage)
    this.bind();
    this.initGlide();
    this.initECommerceTracking();
    if ((_clientData$orderData = clientData.orderData) !== null && _clientData$orderData !== void 0 && _clientData$orderData.customerId && clientData.tplId) this.loadCCData();
    var self = this;
    setTimeout(function () {
      self.submitButtons = $('.btn-loader').toArray();
      for (var i = 0; i < self.submitButtons.length; i++) self.submitButtons[i] = Ladda.create(self.submitButtons[i]);
    }, 1000);

    // GTM Stuff
    var newCheckoutStep = this.currentCheckoutStep();
    var packageLabels = this.getProductCheckoutStep(clientData.product);
    LSCMSUtils.gtmPageViewEvent(window.location.pathname + packageLabels[newCheckoutStep]);

    // For customers selecting dissolution product, select essentials pkg by default [TSL2-151]
    if (clientData && clientData.product && clientData.product.name === "Dissolution" && !LSCart.items.length) {
      $('a[data-option-id="essentials"]').click();
    }
  },
  initAddonButtons: function initAddonButtons() {
    var _LSCart$items;
    (_LSCart$items = LSCart.items) === null || _LSCart$items === void 0 || _LSCart$items.forEach(function (item, i) {
      if (i > 0) if (LSCart.isItemInCart(item.id)) {
        var $elements = $('[data-option-id="' + item.id + '"]');
        $elements.addClass('btn-addon-selected');

        // Only change text for the button
        var $filteredElements = $elements.filter(function () {
          return $(this).hasClass('btn-addon');
        });
        $filteredElements.text('remove');
      }
    });
  },
  bind: function bind() {
    var self = this;
    $('.toggleCCDataAndPayForm').click(function () {
      self.toggleCCDataAndPayForm();
      return false;
    });
    $('.btn-addon').bind('click', function () {
      var optionId = $(this).attr('data-option-id');
      if ($(this).hasClass('btn-add-plan')) {
        var addon = clientData.product.options.find(function (e) {
          return e.id === optionId;
        });
        self.onAddPlanClick(addon, planToggle.currentPlan);
      } else {
        self.onAddOptionClick(optionId);
      }
      if (LSCart.isItemInCart(optionId) || LSCart.isItemParentInCart(optionId)) {
        // change button to "remove"
        $(this).addClass('btn-addon-selected');

        // Only change text for the button
        if ($(this).hasClass('btn-addon')) $(this).text('remove');
        $(this).closest('.card').css({
          'border-color': '#28a745'
        });
        $(this).closest('.card').addClass('selected');

        // fade out feedback "added to cart"
        var $btn = $(this);
        $btn.css({
          'display': 'none',
          'opacity': '0',
          'transition': 'opacity 0.5s ease-in-out'
        });
        var $msg = $('<div class="float-right text-sm text-success semi-bold" style="height: 34px;line-height: 34px;color: #28a745 !important;"><i class="fa fa-check-circle"></i> Added to your cart</div>');
        if ($(this).closest('.card-footer').length) $(this).closest('.card-footer').append($msg);else $(this).closest('div').append($msg);
        setTimeout(function () {
          $msg.remove();
          $btn.css({
            'display': 'block'
          });
          setTimeout(function () {
            $btn.css({
              'opacity': '1'
            });
          }, 50);
        }, 2250);
      } else {
        // change button to "add"
        $(this).removeClass('btn-addon-selected').text('Add');
        $(this).closest('.card').css({
          'border-color': 'rgb(0 0 0 / 8%)'
        });
        $(this).closest('.card').removeClass('selected');
      }
      // remove focus from btn to avoid weird btn state
      $(this).blur();
      return false;
    });
    $('.btn-bundle').bind('click', function () {
      var bundleId = $(this).attr('data-bundle-id');
      var plan = $(this).attr('data-plan-id');

      // $('.btn-addon-selected').removeClass('btn-addon-selected');
      self.onAddBundleClick(bundleId, plan);
      // $(this).addClass('btn-addon-selected');

      // remove focus from btn to avoid weird btn state
      $(this).blur();
      return false;
    });
    $(document).on('click', '.bundle-remove', function () {
      LSCart.removeBundles();
      $('.btn-addon-selected').removeClass('btn-addon-selected');
    });
    $('.package-choice-btn').bind('click', function () {
      var pkgId = $(this).attr('data-package-id');
      self.onAddPackageClick(pkgId);
      $('.btn-addon-selected').toArray().forEach(function (e) {
        $(e).text('Add');
        $(e).removeClass('btn-addon-selected');
      });
      return false;
    });
    $('.cart-package-choice-btn').bind('click', function () {
      var pkgId = $(this).attr('data-option-id');
      var pkgType = $(this).attr('data-option-type');
      var isPackageSelected = $(this).hasClass("btn-package-selected");
      if (!!isPackageSelected) {
        $('.container-add-ons .card').hide();
        LSCart.removeItemFromCart(pkgType, pkgId, true);
        $(this).text('Select').removeClass('btn-package-selected');
        $(this).parents('.product-feature-box').removeClass('package-selected');
      } else {
        self.onAddPackageClick(pkgId, true);
        $('.cart-package-choice-btn').each(function () {
          $(this).text('Select').removeClass('btn-package-selected');
          $(this).parents('.product-feature-box').removeClass('package-selected');
        });
        // fade out feedback "added to cart"
        var $btn = $(this);
        $btn.css({
          'display': 'none',
          'opacity': '0',
          'transition': 'opacity 0.5s ease-in-out'
        });
        var $msg = $('<div class="float-right text-sm text-success semi-bold" style="height: 34px;line-height: 34px;color: #28a745 !important;"><i class="fa fa-check-circle"></i> Added to your cart</div>');
        if ($(this).closest('.card-footer').length) $(this).closest('.card-footer').append($msg);else $(this).closest('div').append($msg);
        setTimeout(function () {
          $msg.remove();
          $btn.css({
            'display': 'block'
          });
          setTimeout(function () {
            $btn.css({
              'opacity': '1'
            });
          }, 50);
        }, 2250);
        $(this).text('Remove').addClass('btn-package-selected');
        $(this).parents('.product-feature-box').addClass('package-selected');
      }
      $('.btn-addon-selected').toArray().forEach(function (e) {
        $(e).text('Add');
        $(e).removeClass('btn-addon-selected');
        $(e).parents('.custom-card-body').removeClass('selected');
      });
      return false;
    });
    $('#payForm form').on('submit', /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
        var $fields, isValid;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!self.isShowingCCData) {
                _context.next = 7;
                break;
              }
              _context.next = 3;
              return LSCheckoutProcessor.onPayFormSubmit(e);
            case 3:
              e.preventDefault();
              return _context.abrupt("return", false);
            case 7:
              $(this).addClass('was-validated');
              if (this.checkValidity()) {
                _context.next = 16;
                break;
              }
              $fields = $('.was-validated *:invalid').toArray();
              isValid = true;
              $fields.forEach(function (f) {
                if ($(f).is(':visible') && isValid) {
                  isValid = false;
                  var pos = $(f).offset().top;
                  $('html, body').animate({
                    scrollTop: pos - 95
                  }, 500);
                }
              });
              e.preventDefault();
              return _context.abrupt("return", false);
            case 16:
              _context.next = 18;
              return LSCheckoutProcessor.onPayFormSubmit(e);
            case 18:
              e.preventDefault();
              return _context.abrupt("return", false);
            case 20:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    // yes this is needed
    // $('.submit-button').bind('click', function () {
    $(document).on('click', '.cart .btn-pay', function () {
      $('#payForm form').submit();
      return false;
    });

    // yes this is needed
    // $('.cart .btn-continue').bind('click', function () {
    $(document).on('click', '.cart .btn-continue, .btn-continue-checkout', function () {
      var newCheckoutStep = self.checkoutStep + 1;
      window.history.pushState(null, null, '#' + newCheckoutStep);
      $(window).trigger('hashchange');
      return false;
    });

    // yes this is needed
    $(document).on('click', '.cart .btn-dashboard', function () {
      self.goToDashboard();
      return false;
    });
    $('.link-t-c').bind('click', function () {
      self.showTAndC();
      return false;
    });

    // $('[data-option-selected="1"]').toArray().forEach(function (e) {
    //     $(e).click();
    // });
  },
  initECommerceTracking: function initECommerceTracking() {
    if (LSCMSUtils.isEECommerceEnabled()) {
      if (typeof [].last === 'undefined') {
        // weird jquery thing...
        Array.prototype.last = function () {
          if (!this.length) return null;
          return this[this.length - 1];
        };
      }

      // GA EECommerce
      // ************************************************************
      GAEECommerce.initialize();
      GAEECommerce.setPageName(clientData.pageName);
      GAEECommerce.clear();
      this.ecProduct = GAEECommerce.createECProduct('product', clientData.product, clientData);
      if (clientData.product.packages) {
        // package pageview
        GAEECommerce.onPackageViewLoad(this.ecProduct.id);
      } else {
        // no package => step: cart review
        GAEECommerce.onProductAdd(this.ecProduct);
        GAEECommerce.onCartReviewLoad(this.ecProduct);
      }
      // ************************************************************

      // Facebook ECommerce
      // ************************************************************
      facebookECommerce.initialize();
      // TODO: missing default product add??
      // ************************************************************
    }
  },
  initGlide: function initGlide() {
    var _this2 = this;
    var self = this;
    this.slider = new Glide('.atf-checkout .glide', {
      type: 'slider',
      startAt: 0,
      perView: 1,
      gap: 50,
      peek: {
        before: 0,
        after: 0
      },
      keyboard: false,
      swipeThreshold: false,
      dragThreshold: false
    }).mount();
    var onBefore = function onBefore() {
      $(window).scrollTop(0);
      self.setGlideHeight();
    };
    var onAfter = function onAfter() {
      // render fixed scrolling cart

      var newCheckoutStep = _this2.currentCheckoutStep();
      var packageLabels = _this2.getProductCheckoutStep(clientData.product);
      var stepName = packageLabels[newCheckoutStep];
      if (stepName === 'cart') LSCart.renderFixedCart('cart');
      if (stepName === 'pay') LSCart.renderFixedCart('payForm');
    };
    self.slider.on('run.before', function () {
      onBefore();
    });
    self.slider.on('run.after', function () {
      onAfter();
    });
    onBefore();
    onAfter();
  },
  setGlideHeight: function setGlideHeight() {
    var height = $($('.atf-checkout .glide__slide')[this.checkoutStep]).children().height();
    $('.atf-checkout .glide__slides').css('height', height + 100 + 'px');
  },
  initPreselectedAddon: function initPreselectedAddon() {
    // debugger;
    var optionId = LSUtils.getQueryStringParameter('optionId');
    var isSelected = LSUtils.getQueryStringParameter('selected');
    if (optionId && (isSelected == '' || isSelected == 'true')) {
      // click on btn to toggle add/remove btn state
      LSCheckout.onAddOptionClick(optionId);
      var $elements = $('[data-option-id="' + optionId + '"]');
      $elements.addClass('btn-addon-selected');

      // Only change text for the button
      var $filteredElements = $elements.filter(function () {
        return $(this).hasClass('btn-addon');
      });
      $filteredElements.text('remove');
      $filteredElements.parents('.custom-card-body').addClass('selected');
      // Hide preselected addon
      $filteredElements.parents('.custom-card-body').addClass('hidden');
      $('[data-option-id="' + optionId + '"]').closest('.card').css({
        'border-color': '#28a745'
      });
    }
  },
  toggleCCDataAndPayForm: function toggleCCDataAndPayForm() {
    if ($('.card-on-file-section').is(':visible')) {
      $('.card-on-file-section').hide();
      $('.form-inputs-section').show();
      $('#pay-form-switch').show();
      this.isShowingCCData = false;
    } else {
      $('.card-on-file-section').show();
      $('.form-inputs-section').hide();
      $('#pay-form-switch').hide();
      this.isShowingCCData = true;
    }
    this.setGlideHeight();
  },
  loadCCData: function loadCCData() {
    var self = this;
    $.ajax({
      url: LSUtils.url() + '/app/services/transaction/?cmd=getCustomer&clientId=' + clientData.clientId,
      success: function success(response) {
        response = JSON.parse(response);
        try {
          if (!response.error) {
            var ccData = response.data.cardData;
            ;
            if (ccData) {
              self.isShowingCCData = true;
              ccData.name = ccData.name ? ccData.name : ccData.owner.name;
              ccData.last4 = ccData.last4 ? ccData.last4 : ccData.card.last4;
              ccData.exp_month = ccData.exp_month ? ccData.exp_month : ccData.card.exp_month;
              ccData.exp_year = ccData.exp_year ? ccData.exp_year : ccData.card.exp_year;
              ccData.brand = ccData.brand ? ccData.brand : ccData.card.brand;
              $('#card-number').val('xxxx xxxx xxxx '.toUpperCase() + ccData.last4);
              $('#card-front #name').val(ccData.name); // old card version for dashboard
              $('#card-front-lg #name').val(ccData.name); // new card version for checkout page
              $('#card-expiration').val(ccData.exp_month + '/' + ccData.exp_year);
              if (ccData.brand === 'Visa') {
                $('#cc_logo_visa').show();
                $('#cc_logo_mc').hide();
                $('#cc_logo_amex').hide();
              } else if (ccData.brand === 'MasterCard') {
                $('#cc_logo_mc').show();
                $('#cc_logo_amex').hide();
                $('#cc_logo_visa').hide();
              } else if (ccData.brand === 'American Express') {
                $('#cc_logo_amex').show();
                $('#cc_logo_visa').hide();
                $('#cc_logo_mc').hide();
              } else {
                $('#cc_logo_visa').hide();
                $('#cc_logo_mc').hide();
                $('#cc_logo_amex').css('opacity', 0);
              }
            } else {
              self.toggleCCDataAndPayForm();
            }
          } else {
            self.toggleCCDataAndPayForm();
          }
        } catch (ex) {
          $('#cc_logo_visa').hide();
          $('#cc_logo_mc').hide();
          $('#cc_logo_amex').css('opacity', 0);
          self.toggleCCDataAndPayForm();
        }
      }
    });
  },
  onhashchange: function onhashchange() {
    var newCheckoutStep = this.currentCheckoutStep();
    var packageLabels = this.getProductCheckoutStep(clientData.product);
    LSCMSUtils.gtmPageViewEvent(window.location.pathname + packageLabels[newCheckoutStep]);
    var self = this;
    setTimeout(function () {
      if (self.slider) {
        self.slider.go('=' + newCheckoutStep);
        self.updateStepper();
      } else console.log('Slider not defined');
    }, 100);
    this.checkoutStep = newCheckoutStep;
  },
  onAddPackageClick: function onAddPackageClick(pkgId) {
    var skipUrlChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    LSCart.addPackage(pkgId);
    if (!skipUrlChange) {
      var newCheckoutStep = this.checkoutStep + 1;
      window.history.pushState(null, null, '#' + newCheckoutStep);
      $(window).trigger('hashchange');
    }
    LSCart.removeBundles();

    // GA EECommerce
    // ************************************************************
    if (LSCMSUtils.isEECommerceEnabled()) {
      var package_ = null;
      clientData.product.packages.forEach(function (p) {
        if (p.id === pkgId) package_ = p;
      });
      var pkgPrice = package_.price;
      var nonTaxableAmount = package_.nonTaxableAmount ? package_.nonTaxableAmount : clientData.product.nonTaxableAmount;
      if (nonTaxableAmount) {
        // get the actual svc price w/o tax and w/o ch
        pkgPrice = (package_.price * (1 + 0.2) - nonTaxableAmount) / 1.2;
        pkgPrice = parseFloat(pkgPrice.toFixed(2));
      }
      this.ecProduct.variant = package_.id;
      this.ecProduct.price = pkgPrice;
      GAEECommerce.onProductAdd(this.ecProduct);
      GAEECommerce.onCartReviewLoad();
    }
    // ************************************************************
  },
  onAddPlanClick: function onAddPlanClick(selectedPkg, planId) {
    var ecProduct;
    var plan;
    var plans = selectedPkg !== null && selectedPkg !== void 0 && selectedPkg.stripe ? selectedPkg.stripe.plans : clientData.product.stripe.plans;
    plans.forEach(function (o) {
      if (o.id === planId) plan = o;
    });

    // GA EECommerce
    // ************************************************************
    if (LSCMSUtils.isEECommerceEnabled()) {
      ecProduct = GAEECommerce.createECProduct('option', plan, clientData);
    }
    // ************************************************************

    if (LSCart.isItemInCart(planId)) {
      LSCart.removePlan();
    } else {
      LSCart.addPlan(selectedPkg, planId);
    }
    // GA EECommerce
    // ************************************************************
    if (LSCMSUtils.isEECommerceEnabled()) {
      GAEECommerce.onOptionAdd(ecProduct);
    }
    // ************************************************************
  },
  onAddOptionClick: function onAddOptionClick(optionId) {
    // GA EECommerce
    // ************************************************************
    if (LSCMSUtils.isEECommerceEnabled()) {
      var option = null;
      clientData.product.options.forEach(function (o) {
        if (o.id === optionId) option = o;
      });
      var ecProduct = GAEECommerce.createECProduct('option', option, clientData);
    }
    // ************************************************************

    if (LSCart.isItemInCart(optionId)) {
      LSCart.removeAddon(optionId);
      // GA EECommerce
      // ************************************************************
      if (LSCMSUtils.isEECommerceEnabled()) {
        GAEECommerce.onOptionRemove(ecProduct);
      }
      // ************************************************************
    } else {
      LSCart.addAddon(optionId);
      // GA EECommerce
      // ************************************************************
      if (LSCMSUtils.isEECommerceEnabled()) {
        GAEECommerce.onOptionAdd(ecProduct);
      }
      // ************************************************************
    }
  },
  onAddBundleClick: function onAddBundleClick(bundleId, plan) {
    LSCart.removeBundles();
    LSCart.addBundle(bundleId, plan);
  },
  showTAndC: function showTAndC() {
    var path = '/termsAndConditions';
    var $iframe = $('<iframe src="' + LSUtils.url() + path + '?header=no&footer=no" style="border: none; width: 100%; height: 450px;overflow:hidden;"></iframe>');
    this.popup = BootstrapDialog.show({
      closable: true,
      title: 'Terms & Conditions',
      message: $iframe
    });
  },
  getEmail: function getEmail() {
    var _clientData$emails;
    var result = null;
    var $emailFields = $('[name="email"]');
    $emailFields.toArray().forEach(function (emailField) {
      if ($(emailField).val()) {
        result = $(emailField).val();
      }
    });
    return result || ((_clientData$emails = clientData.emails) === null || _clientData$emails === void 0 ? void 0 : _clientData$emails.contact);
  },
  goToDashboard: function goToDashboard() {
    var self = this;
    var $email = $('[name="email"]:visible', $('.cart-footer'));
    if (!LSUtils.validateEmail($email.val())) {
      $email.css('border-color', 'red');
      return false;
    }
    LSCMSUtils.saveEmail($email.val());
    if (!window.isRedirecting) {
      self.submitButtons.map(function (btn) {
        btn.start();
      });
      LSStripe.post('FREE KEY', $('[name="email"]', $('#cart')).val()).done(function (resp) {
        window.isRedirecting = true;
        window.location.href = LSUtils.url() + '/status/?clientId=' + clientData.clientId;
      });
    }
  },
  updateStepper: function updateStepper() {
    $('#stepper-desktop .col-step-active').removeClass('col-step-active');
    $('#stepper-mobile .col-step-content').hide();
    if (clientData.product.packages) {
      if (this.checkoutStep <= 1) {
        $('#stepper-desktop .single-step:nth(' + 1 + ') .col-step-content').addClass('col-step-active');
        $('#stepper-mobile .col-step-content:nth(' + 1 + ')').show();
      } else {
        $('#stepper-desktop .single-step:nth(' + 2 + ') .col-step-content').addClass('col-step-active');
        $('#stepper-mobile .col-step-content:nth(' + 2 + ')').show();
      }
      if (this.checkoutStep === 2) LSStripe.showPaymentRequestBtn();
    } else {
      // nth-child is 1 based, so starts from 1, not 0
      $('#stepper-desktop .single-step:nth-child(' + (this.checkoutStep + 1) + ') .col-step-content').addClass('col-step-active');
      $('#stepper-mobile .col-step-content:nth-child(' + (this.checkoutStep + 1) + ')').show();
      if (this.checkoutStep === 1) LSStripe.showPaymentRequestBtn();
    }
  },
  createOptionPendingCharge: function createOptionPendingCharge(optionId, qty, price, shipping, clientId) {
    qty = qty ? qty : -1;
    price = price ? price : -1;
    shipping = shipping ? shipping : 0;
    return $.ajax({
      url: LSUtils.url() + '/app/services/lstransaction',
      data: {
        cmd: 'createOptionPendingCharge',
        clientId: typeof clientId !== 'undefined' ? clientId : $('[name="clientId"]').val(),
        optionId: optionId,
        qty: qty,
        price: price,
        shipping: shipping
      }
    });
  },
  getRealServicePrice: function getRealServicePrice(priceWoVAT, nonTaxableAmount) {
    // get the actual svc price w/o tax and w/o ch
    return (priceWoVAT * (1 + 0.2) - nonTaxableAmount) / 1.2;
  },
  getProductCheckoutStep: function getProductCheckoutStep(cstProduct) {
    var checkoutSteps = ['pkg', 'cart', 'pay'];
    if (cstProduct.bundles) {
      checkoutSteps = ['bundles', 'pay'];
    } else if (!cstProduct.packages) {
      checkoutSteps = ['cart', 'pay'];
    }
    if (typeof checkoutWithSearchResults != 'undefined') {
      if (checkoutWithSearchResults.qsCompany) {
        checkoutSteps = ['search'].concat(checkoutSteps);
      }
    }
    if (cstProduct.name.toLowerCase() === "dissolution") {
      checkoutSteps = ['search', 'cart', 'pay'];
    }
    return checkoutSteps;
  },
  currentCheckoutStep: function currentCheckoutStep() {
    var newCheckoutStep = 0;
    var crtHref = location.hash;
    if (crtHref.includes('#')) newCheckoutStep = parseInt(crtHref.replace('#', ''));
    return newCheckoutStep;
  }
};
export { LSCheckout };